import { render, staticRenderFns } from "./Authenticator.vue?vue&type=template&id=2fbfe082&scoped=true&"
import script from "./Authenticator.vue?vue&type=script&lang=ts&"
export * from "./Authenticator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbfe082",
  null
  
)

export default component.exports